import React from "react";

import unityCoBrandedLogo from "../../../assets/logos/unity-rebrand/unity-horiz-cobranded-tint.svg";

import {
  HeaderContainer,
  HeaderContent,
  HeaderLogo,
  HeaderSubtitle,
} from "./PhlebotomyHeader.styles";

interface PhlebotomyHeaderProps {
  subtitle?: string;
}

const PhlebotomyHeader: React.FC<PhlebotomyHeaderProps> = ({ subtitle }) => (
  <HeaderContainer hasSubtitle={Boolean(subtitle)}>
    <HeaderContent>
      <HeaderLogo src={unityCoBrandedLogo} alt="Unity by BillionToOne" />
      {subtitle && <HeaderSubtitle>{subtitle}</HeaderSubtitle>}
    </HeaderContent>
  </HeaderContainer>
);

export default PhlebotomyHeader;
